import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export const onEntryPointClick = ({ jsonQuery, regionId }: { jsonQuery: IJsonQuery; regionId: number }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry',
    action: 'Click_sopr',
    label: 'Click',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onEntryAutorisationPopupOpen = ({
  jsonQuery,
  label,
  regionId,
}: {
  jsonQuery: IJsonQuery;
  label: string;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Show_sopr',
    label,
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onEntryAutorisationPopupClick = ({
  jsonQuery,
  label,
  regionId,
}: {
  jsonQuery: IJsonQuery;
  label: string;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Click_sopr',
    label,
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onOpenChatPopup = ({
  label,
  chatId,
  botId,
  ownerId,
  regionId,
}: {
  label: string;
  chatId: string;
  botId: number;
  ownerId?: number;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label,
    useLastProducts: true,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        chat_id: chatId,
        bot_id: botId,
        owner_id: ownerId,
        region: regionId,
      },
    },
  });

export const onAnimationShown = ({ label }: { label: string }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_animation',
    action: 'Show_sopr',
    label,
    useLastProducts: true,
  });

export const onAnimationTooltipShown = ({ label }: { label: string }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_tooltip',
    action: 'Show_sopr',
    label,
    useLastProducts: true,
  });
